// extracted by mini-css-extract-plugin
export var actions = "_23-0";
export var actionsContainer = "_23-7";
export var border = "_23-1";
export var childFullHeight = "_23-f";
export var collapse = "_23-2";
export var content = "_23-a";
export var contentChild = "_23-e";
export var fullscreen = "_23-c";
export var hasLeftRadius = "_23-k";
export var headerContainer = "_23-3";
export var headerRow = "_23-5";
export var hidePadding = "_23-b";
export var navCollapsedGap = "_23-l";
export var noScrollX = "_23-m";
export var noScrollY = "_23-n";
export var noTopPadding = "_23-i";
export var optOutTopPadding = "_23-d";
export var pageMain = "_23-j";
export var pageOuter = "_23-g";
export var pagePadding = "_23-8";
export var pageScroll = "_23-9";
export var profile = "_23-o";
export var profileContainer = "_23-p";
export var profileImage = "_23-q";
export var profileMain = "_23-r";
export var profileSubtitle = "_23-t";
export var profileTitle = "_23-s";
export var showLeftPadding = "_23-h";
export var tabsPortalSlot = "_23-6";
export var tabsWrapper = "_23-4";
export var title = "_23-u";